import { BarnestipendSatser } from './BarnestipendApi';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';

const mapVariabler = (satser: BarnestipendSatser, locale: string): Map<string, string> => {
    const map = new Map<string, string>();
    map.set('${GrenseFormueAlene}', tilPengerFormat(satser.SATS_ST04_FORMUEGRENSE_ENSLIG, locale));
    return map;
};

export default mapVariabler;
